import axios from '../../axios'

// 新增院校专业评级
export const addProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level',
        method: 'POST',
        data
    })
}

// 获取院校专业评级详情
export const getProfLevelInfo = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level/info',
        method: 'GET',
        data
    })
}

// 修改院校专业评级信息
export const editProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level',
        method: 'PUT',
        data
    })
}

// 删除院校专业评级信息
export const deleteProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索院校专业评级信息列表
export const getProfLevelList = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level',
        method: 'GET',
        data
    })
}

// 院校专业评级信息导入
export const importProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level/import',
        method: 'POST',
        data
    })
}

// 院校专业评级信息导出
export const exportProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level/export',
        method: 'POST',
        data
    })
}

// 院校专业评级信息批量更新
export const updateProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level/batch/update',
        method: 'POST',
        data
    })
}

// 院校专业评级信息批量删除
export const queryDeleteProfLevel = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level/batch/delete',
        method: 'POST',
        data
    })
}

// 院校专业评级信息检测对比导出
export const profLevelTestExport = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/level/check',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/proflevel.js